
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/addresses",
      function () {
        return require("private-next-pages/addresses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/addresses"])
      });
    }
  